
import { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

import LogoHeader from '../Assets/Image/Hiranand Agri solutions.png'
import '../Assets/Css/webheader.css';
import { FaHome, FaSeedling, FaHandsHelping, FaLeaf, FaImages, FaEnvelopeOpenText ,FaLaptopCode} from 'react-icons/fa';
import { GiWheat } from 'react-icons/gi';
import { FaTools,FaWarehouse } from "react-icons/fa";
import { NavDropdown } from 'react-bootstrap';
import { FaAngleDown } from "react-icons/fa";
import { useLocation } from 'react-router-dom';

function WebHeader() {

  const [showSidebar, setShowSidebar] = useState(false);
  const [navbarSolid, setNavbarSolid] = useState(false);

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);
  const [topHeaderScrolled, setTopHeaderScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const isMobile = window.innerWidth <= 768;
      const bannerHeight = isMobile ? 0.7 * window.innerHeight : window.innerHeight;

      setNavbarSolid(scrollTop > bannerHeight - 200);
      setTopHeaderScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navigate = useNavigate();

  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggleManually = (e) => {
    e.preventDefault(); // stop default toggle behavior
    setShowDropdown(!showDropdown);
  };
  const location = useLocation();

const isFacilitiesActive =
  location.pathname.startsWith('/facilities') ||
  location.pathname === '/facilities/Agri' ||
  location.pathname === '/facilities/it-digital';

const handleMouseEnter = () => setShowDropdown(true);
const handleMouseLeave = () => setShowDropdown(false);

  return (
    <>
<div className="top-header translate-top text-end p-2 ">
  <div id="google_translate_element" />
</div>
      
      <Navbar expand="lg" className={`custom-navbar ${navbarSolid ? 'navbar-solid scrolled' : 'navbar-transparent'}`}>
  
        <Container className="d-flex justify-content-between align-items-center ">
          

          <Navbar.Brand href='/'>
            <span onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
              <img
                src={LogoHeader}
                alt="Logo"
                className={`navbar-logo ${navbarSolid ? "scrolled" : ""}`}
              />
            </span>
          </Navbar.Brand>
           
         
          
          <Navbar.Toggle aria-controls="offcanvasNavbar" onClick={handleShow} className="d-lg-none" />
      <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center d-none d-lg-flex">
  <Nav>
    <Nav.Link as={NavLink} to="/" onClick={handleClose}>Home</Nav.Link>
    <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>About Us</Nav.Link>
    <Nav.Link as={NavLink} to="/services" onClick={handleClose}>Services</Nav.Link>
 <NavDropdown
  title={
    <span className="nav-dropdown-toggle" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      Facilities <FaAngleDown style={{ fontSize: '0.7rem' }} />
    </span>
  }
  id="facilities-nav-dropdown"
  className={`custom-dropdown ${isFacilitiesActive ? 'active' : ''}`}
  show={showDropdown}
  onMouseEnter={() => window.innerWidth > 991 && setShowDropdown(true)}
  onMouseLeave={() => window.innerWidth > 991 && setShowDropdown(false)}
  onClick={() => window.innerWidth <= 991 && setShowDropdown(prev => !prev)}
>
  <NavDropdown.Item as={NavLink} to="/facilities/agri" onClick={handleClose}>
    <FaLeaf className="me-2" /> HASPL Agri Facility
  </NavDropdown.Item>
  <NavDropdown.Item as={NavLink} to="/facilities/it-digital" onClick={handleClose}>
    <FaLaptopCode className="me-2" /> HASPL IT & Digital Services
  </NavDropdown.Item>
</NavDropdown>


    <Nav.Link as={NavLink} to="/products" onClick={handleClose}>Products</Nav.Link>
    <Nav.Link as={NavLink} to="/gallery" onClick={handleClose}>Gallery</Nav.Link>
    <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>Contact</Nav.Link>
  </Nav>
</Navbar.Collapse>

        </Container>
      </Navbar>

    <Offcanvas
  show={showSidebar}
  onHide={handleClose}
  placement="start"
  className="custom-offcanvas"
>
  <Offcanvas.Header closeButton>
    <Offcanvas.Title>
      <img src={LogoHeader} alt="Logo" className="navbar-logo" />
    </Offcanvas.Title>
  </Offcanvas.Header>

  <Offcanvas.Body className='offcanvasbody'>
  <Nav className="flex-column">

  <Nav.Link as={NavLink} to="/" onClick={handleClose}>
    <FaHome size={18} className="me-2" /> Home
  </Nav.Link>

  <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>
    <FaSeedling size={18} className="me-2" /> About Us
  </Nav.Link>

  <Nav.Link as={NavLink} to="/services" onClick={handleClose}>
    <FaHandsHelping size={18} className="me-2" /> Services
  </Nav.Link>


    <Nav.Link as={NavLink} to="/facilities/agri" onClick={handleClose}>
      <FaLeaf size={16} className="me-2" /> HASPL Agri Facility
    </Nav.Link>
    <Nav.Link as={NavLink} to="/facilities/it-digital" onClick={handleClose} >
      <FaLaptopCode size={16} className="me-2" /> HASPL IT & Digital Services
    </Nav.Link>


  <Nav.Link as={NavLink} to="/products" onClick={handleClose}>
    <GiWheat size={18} className="me-2" /> Products
  </Nav.Link>

  <Nav.Link as={NavLink} to="/gallery" onClick={handleClose}>
    <FaImages size={18} className="me-2" /> Gallery
  </Nav.Link>

  <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
    <FaEnvelopeOpenText size={18} className="me-2" /> Contact
  </Nav.Link>


  </Nav>
</Offcanvas.Body>

</Offcanvas>


    

      {/* Mobile Bottom Navigation */}
      <Navbar fixed="bottom" className="mobile-bottom-nav d-lg-none">
        <Nav className="w-100 d-flex justify-content-around">
          <Nav.Link as={NavLink} to="/" onClick={handleClose}>
            <FaHome size={20} />
            <span className="nav-label">Home</span>
          </Nav.Link>
          <Nav.Link as={NavLink} to="/aboutus" onClick={handleClose}>
            <FaSeedling size={20} />
            <span className="nav-label">About</span>
          </Nav.Link>
          <Nav.Link as={NavLink} to="/services" onClick={handleClose}>
            <FaHandsHelping size={20} />
            <span className="nav-label">Services</span>
          </Nav.Link>
    
{/* Facilities Dropdown for Mobile */}
    <NavDropdown
      title={
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <FaWarehouse size={20} />
          <span className="nav-label">Facilities</span>
        </div>
      }
      id="mobile-facilities-dropdown"
      className="mobile-nav-dropdown"
      drop="up"
    >
      <NavDropdown.Item as={NavLink} to="/facilities/agri" onClick={handleClose}>
        <FaLeaf className="me-2" /> HASPL Agri Facility
      </NavDropdown.Item>
      <NavDropdown.Item as={NavLink} to="/facilities/it-digital" onClick={handleClose}>
        <FaLaptopCode className="me-2" /> 
        
      </NavDropdown.Item>
    </NavDropdown>

          <Nav.Link as={NavLink} to="/products" onClick={handleClose}>
            <GiWheat size={20} />
            <span className="nav-label">Products</span>
          </Nav.Link>
          <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
            <FaEnvelopeOpenText size={20} />
            <span className="nav-label">Contact</span>
          </Nav.Link>
        </Nav>
      </Navbar>



    </>
  );
}

export default WebHeader;
